import { render, staticRenderFns } from "./leave-table.vue?vue&type=template&id=394b6501&scoped=true&"
import script from "./leave-table.vue?vue&type=script&lang=js&"
export * from "./leave-table.vue?vue&type=script&lang=js&"
import style0 from "./leave-table.vue?vue&type=style&index=0&id=394b6501&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b6501",
  null
  
)

export default component.exports